import { lazy } from 'react'

import { AnyRoute, createRoute, notFound, useLoaderData } from '@tanstack/react-router'
import { getOnboardingDocumentEditModeWebPage } from 'commons/service/bank/onboardingDocuments'
import { OnboardingDocumentEditModeWebPage } from 'commons/types/DTO/bank/applications/onboardingDocuments'

import { Sidebar } from '../../components/Sidebar'

const OnboardingDocumentsEdit = lazy(() => import('./OnboardingDocumentsEdit'))

export const onboardingDocumentsEditRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$id/edit',
    loader: async ({ params }) => {
      const { id } = params as {
        id: string
      }

      const response: OnboardingDocumentEditModeWebPage = await getOnboardingDocumentEditModeWebPage(Number(id) || 0)

      if (!response?.companies) {
        throw notFound()
      }

      return {
        webPageData: response
      }
    },
    component: () => {
      const { webPageData } = useLoaderData({ strict: false })

      if (!webPageData) throw notFound()

      return (
        <>
          <Sidebar companies={webPageData.companies} />
          <OnboardingDocumentsEdit />
        </>
      )
    },
    shouldReload: (p) => p.cause === 'enter'
  })
